import api from './api';

// AKM POC §9.2 — yönetici: çalışanın giriş kilidi (hatalı parola denemeleri). Durum { hasAccount, locked, lockedUntil };
// kilidi açılan kullanıcı e-postayla bilgilendirilir, işlem geçmişine "account.unlocked" düşer.
export const getEmployeeLoginLock = (employeeId) => api.get(`/v1/employees/${employeeId}/login-lock`);
export const unlockEmployeeLogin = (employeeId) => api.post(`/v1/employees/${employeeId}/login-lock/unlock`);
